import React, { useState } from 'react';
import {
  Alert,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import DashboardLayout from '../components/DashboardLayout';

const roles = ['All', 'Admin', 'Instructor', 'Student'];
const students = [
  { id: 1, name: 'Anele Khumalo' },
  { id: 2, name: 'Thandi Mokoena' },
  { id: 3, name: 'Sipho Dlamini' },
];

const Notifications = () => {
  const [selectedRole, setSelectedRole] = useState('All');
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [message, setMessage] = useState('');
  const [feedback, setFeedback] = useState(null);

  const handleStudentToggle = (id) => {
    setSelectedStudents((current) => (
      current.includes(id) ? current.filter((studentId) => studentId !== id) : [...current, id]
    ));
  };

  const handleSend = () => {
    if (!message.trim()) {
      setFeedback({ severity: 'warning', message: 'Enter a message before sending.' });
      return;
    }
    const recipients = selectedRole === 'Student' && selectedStudents.length
      ? students.filter((student) => selectedStudents.includes(student.id)).map((student) => student.name).join(', ')
      : selectedRole === 'All' ? 'all users' : `${selectedRole.toLowerCase()}s`;
    setFeedback({ severity: 'success', message: `Message prepared for ${recipients}.` });
    setMessage('');
    setSelectedStudents([]);
  };

  return (
    <DashboardLayout>
      <Card sx={{ maxWidth: 820 }}>
        <CardHeader title="Send notification" subheader="Send a targeted in-app notification to a role or selected learners." />
        <CardContent>
          <Stack spacing={2.5}>
            {feedback ? <Alert severity={feedback.severity} onClose={() => setFeedback(null)}>{feedback.message}</Alert> : null}
            <FormControl fullWidth>
              <InputLabel id="notification-role-label">Audience</InputLabel>
              <Select
                labelId="notification-role-label"
                label="Audience"
                value={selectedRole}
                onChange={(event) => {
                  setSelectedRole(event.target.value);
                  setSelectedStudents([]);
                  setFeedback(null);
                }}
              >
                {roles.map((role) => <MenuItem key={role} value={role}>{role}</MenuItem>)}
              </Select>
            </FormControl>

            {selectedRole === 'Student' ? (
              <FormControl component="fieldset">
                <InputLabel shrink sx={{ position: 'static', transform: 'none', mb: 1 }}>Optional learner selection</InputLabel>
                <FormGroup row>
                  {students.map((student) => (
                    <FormControlLabel
                      key={student.id}
                      control={<Checkbox checked={selectedStudents.includes(student.id)} onChange={() => handleStudentToggle(student.id)} />}
                      label={student.name}
                    />
                  ))}
                </FormGroup>
              </FormControl>
            ) : null}

            <TextField
              label="Message"
              value={message}
              onChange={(event) => {
                setMessage(event.target.value);
                setFeedback(null);
              }}
              placeholder="Write the notification message"
              minRows={5}
              multiline
              fullWidth
            />
            <Button variant="contained" startIcon={<SendRoundedIcon />} onClick={handleSend} sx={{ alignSelf: 'flex-start' }}>
              Send message
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default Notifications;
